"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_fileprovider_store_1 = require("owa-fileprovider-store");
var legacy_1 = require("satcheljs/lib/legacy");
var isInitialized = false;
exports.default = legacy_1.action('initializeStorageAccountsOption')(function initializeStorageAccountsOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!isInitialized) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_fileprovider_store_1.lazyGetAllFileProviders.import()];
                case 1:
                    // Get the all file providers
                    (_a.sent())();
                    isInitialized = true;
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initializeStorageAccountsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-storage-accounts-option/lib/actions/initializeStorageAccountsOption.js
// module id = 5000
// module chunks = 2